<template>
  <div class="row">
    <div class="col-sm-12 col-md-12 col-lg-12 col-xl-4">
      <div class="card">
        <div style="position:absolute;" class="card-header pl-2 pt-1 p-0">
          <b-tooltip target="button-4"
            ><span class="letter"
              >Total de envíos hechos a la región
              {{ modelJurisdiction.currentJurisdiction }} de enero 2022 a la
              actualidad.</span
            >
          </b-tooltip>
          <i id="button-4" class="feather icon-globe info-color"></i>
        </div>
        <div class="card-body">
          <div class="row align-items-center ">
            <div class="col-4 text-center align-center">
              <h3 class="h3">
                <i class="feather icon-truck fa-2x mr-3"></i>
              </h3>
            </div>
            <div class="col-8 pl-0">
              <span class="font-12 text-uppercase"
                >Enero 2022 - Actualidad</span
              >

              <ul class="list-inline mb-0 mt-1">
                <li>
                  <h4 class="mb-2">
                    {{ numeral(shipmentCount).format("0,0") }}
                  </h4>
                </li>
              </ul>
              <h5 class="font-15">
                ENVÍOS GENERADOS A {{ modelJurisdiction.currentJurisdiction }}
              </h5>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-12 col-md-12 col-lg-6 col-xl-4">
      <div class="card">
        <div style="position:absolute;" class="card-header pl-2 pt-1 p-0">
          <b-tooltip target="button-5"
            ><span class="letter"
              >Total de recetas dispensadas en todas las farmacias de la región
              {{ modelJurisdiction.currentJurisdiction }} de enero 2022 a la
              actualidad.</span
            >
          </b-tooltip>
          <i id="button-5" class="feather icon-globe info-color"></i>
        </div>
        <div class="card-body">
          <div class="row align-items-center ">
            <div class="col-4 text-center align-center">
              <h3 class="h3">
                <i class="feather icon-user-plus fa-2x"></i>
              </h3>
            </div>
            <div class="col-8 pl-0">
              <span class="font-12 text-uppercase"
                >Enero 2022 - Actualidad</span
              >

              <ul class="list-inline mb-0 mt-1">
                <li>
                  <h4 class="mb-2">
                    {{ numeral(prescriptionCount).format("0,0") }}
                  </h4>
                </li>
              </ul>
              <h5 class="font-15">
                RECETAS SURTIDAS EN {{ modelJurisdiction.currentJurisdiction }}
              </h5>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-12 col-md-12 col-lg-6 col-xl-4">
      <div class="card">
        <div style="position:absolute;" class="card-header pl-2 pt-1 p-0">
          <b-tooltip target="button-6"
            ><span class="letter"
              >Total de piezas dispensadas en todas las farmacias de la región
              {{ modelJurisdiction.currentJurisdiction }} enero 2022 a la
              actualidad.</span
            >
          </b-tooltip>
          <i id="button-6" class="feather icon-globe info-color"></i>
        </div>
        <div class="card-body">
          <div class="row align-items-center ">
            <div class="col-4 text-center align-center">
              <h3 class="h3">
                <i class="feather icon-package fa-2x"></i>
              </h3>
            </div>
            <div class="col-8 pl-0">
              <span class="font-12 text-uppercase"
                >Enero 2022 - Actualidad</span
              >
              <ul class="list-inline mb-0 mt-1">
                <li>
                  <h4 class="mb-2">
                    {{ numeral(pieceCount).format("0,0") }}
                  </h4>
                </li>
              </ul>
              <h5 class="font-15">
                PIEZAS DISPENSADAS EN
                {{ modelJurisdiction.currentJurisdiction }}
              </h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import gsap from "gsap";

export default {
  data() {
    return {
      numeral: require("numeral"),
      pieceCount: 0,
      prescriptionCount: 0,
      shipmentCount: 0,
    };
  },
  computed: {
    // Extración del state
    ...mapState("jurisdiction", {
      modelDetails: "modelDetails",
      modelJurisdiction: "modelJurisdiction",
    }),
  },
  created() {
    gsap.to(this, { duration: 0.5, pieceCount: this.modelDetails.pieceCount });
    gsap.to(this, {
      duration: 0.5,
      shipmentCount: this.modelDetails.shipmentCount,
    });
    gsap.to(this, {
      duration: 0.5,
      prescriptionCount: this.modelDetails.prescriptionCount,
    });
  },
  watch: {
    "modelDetails.pieceCount": {
      handler: function(val) {
        gsap.to(this, { duration: 0.5, pieceCount: val });
      },
    },
    "modelDetails.prescriptionCount": {
      handler: function(val) {
        gsap.to(this, { duration: 0.5, prescriptionCount: val });
      },
    },
    "modelDetails.shipmentCount": {
      handler: function(val) {
        gsap.to(this, { duration: 0.5, shipmentCount: val });
      },
    },
  },
};
</script>

<style scoped src="@/other/assets/css/app.css"></style>
<style scoped></style>
